import { render, staticRenderFns } from "./NSwap.vue?vue&type=template&id=2f20ff1b&scoped=true&"
import script from "./NSwap.vue?vue&type=script&lang=js&"
export * from "./NSwap.vue?vue&type=script&lang=js&"
import style0 from "./NSwap.vue?vue&type=style&index=0&id=2f20ff1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f20ff1b",
  null
  
)

export default component.exports